export type ProductCategoryStatusMessages = {
  notFoundError: string;
  notFoundDescription: string;
  notFoundAlt: string;
  errorToLoad: string;

  categoryCreateError: string;
  categoryUpdateError: string;
  categoryCreateSuccess: string;
  categoryUpdateSuccess: string;
};

export const PRODUCT_CATEGORY_STATUS_MESSAGES: ProductCategoryStatusMessages = {
  notFoundError: "Categoria Não Encontrada",
  notFoundDescription: "Desculpe, não conseguimos encontrar nenhuma categoria correspondente.",
  notFoundAlt: "Sem categoria encontrada",
  errorToLoad: "Erro ao Carregar Categorias",

  categoryCreateError: "Erro na criação da categoria!",
  categoryUpdateError: "Erro ao salvar a categoria!",
  categoryCreateSuccess: "Categoria criada com sucesso!",
  categoryUpdateSuccess: "Categoria atualizada com sucesso!",
};
